<template>
    <div class="popup popup--success" id="success" data-location="/catalog/">
        <div class="popup__text">
            <div class="popup__close popup__close--back"></div>
            <div class="popup__text-title">Ваш заказ №{{ order_id }} успешно оформлен <br>Спасибо за покупку!</div>
            <div class="popup__text-description">Мы свяжемся с вами по телефону, как только ваш заказ будет готов к выдаче</div>
        </div>
        <div class="popup__block">
            <div class="popup-success">
                <div class="popup-success__items">
                    <div class="popup-success__item">
                        <div class="popup-success__item-title">Тип доставки</div>
                        <div class="popup-success__item-value">{{ delivery_type }}</div>
                    </div>
                    <div class="popup-success__item">
                        <div class="popup-success__item-title">Адрес</div>
                        <div class="popup-success__item-value">{{ address }}</div>
                    </div>
                    <div class="popup-success__item">
                        <div class="popup-success__item-title">Тип оплаты</div>
                        <div class="popup-success__item-value">{{ payment_type }}</div>
                    </div>
                </div>
                <div class="popup-success__total">
                    <div class="popup-success__price">
                        <div class="popup-success__price-title">Итоговая стоимость</div>
                        <div class="popup-success__price-cost">{{ new Intl.NumberFormat('ru-RU', {style: 'currency', currency: 'RUB'}).format(total) }}</div>
                    </div>
                    <a class="popup-success__btn btn" href="/catalog/">В каталог</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name : "OrderSuccess",
    props: {
        order_id     : Number,
        delivery_type: String,
        address      : String,
        payment_type : String,
        total        : Number
    }
}
</script>

<style scoped>

</style>